import { BaseHTTPClient } from '../api/http-client.service';
import { APIType } from '../api/configuration';
import { ApiConfig } from '../api/api-service/api-config.model';

export class ReportGeneratorService extends BaseHTTPClient {
   public static async addParsedItem(payload: any) {
      return this.sendToGateway({
         url: `${process.env.REACT_APP_API_URL}/documents/parse`,
         method: 'UPLOAD',
         data: payload,
      });
   }
   public static async getReportGenerator(payload: any) {
      return this.sendToGateway({
         url: `${process.env.REACT_APP_API_URL}/documents/upload`,
         method: APIType.POST,
         data: payload,
      });
   }
   public static async updateReportSections(payload: any) {
      return this.sendToGateway({
         url: `${process.env.REACT_APP_API_URL}/generate_execution_flow`,
         method: APIType.POST,
         data: payload,
      });
   }
   public static async updateReportSectionsWeeklyReport(payload: any) {
      return this.sendToGateway({
         url: `${process.env.REACT_APP_API_URL}/generate_execution_flow_weekly_summary`,
         method: APIType.POST,
         data: payload,
      });
   }
   public static async riskScoreGenAI(payload: any) {
      return this.sendToGateway({
         url: `${process.env.REACT_APP_API_URL}/riskScoreGenAI/`,
         method: APIType.POST,
         data: payload,
      });
   }
   public static async calculateRiskScore(payload: any) {
      return this.sendToGateway({
         url: `${process.env.REACT_APP_API_URL}/riskScoreCalculate`,
         method: APIType.POST,
         data: payload,
      });
   }

   public static async checkAndCorrectText(payload: any) {
      return this.sendToGateway({
         url: `${process.env.REACT_APP_API_URL}/lang-check`,
         method: APIType.POST,
         data: payload,
      });
   }
   public static async createReport(payload: any) {
      return this.sendToGateway({
         url: `${process.env.REACT_APP_API_URL}/reports`,
         method: APIType.POST,
         data: payload,
      });
   }

   public static async updateReport(payload: any) {
    return this.sendToGateway({
      url: `${process.env.REACT_APP_API_URL}/reports_id`,
      method: APIType.PUT,
      data: payload,
    });
  }
  
   public static async getReportByID(payload: any) {
      const queryParams = [`report_id=${payload.report_id}`];
      if (payload?.isAiaTenant && payload?.version_id) {
         queryParams.push(`version_id=${payload.version_id}`);
      }
      return this.sendToGateway({
         url: `${process.env.REACT_APP_API_URL}/reports_id?${queryParams.join('&')}`,
         method: APIType.GET,
      });
   }

   public static async createFinding(payload: any) {
      return this.sendToGateway({
         url: `${process.env.REACT_APP_API_URL}/findings`,
         method: APIType.POST,
         data: payload,
      });
   }

   public static async deleteFinding(payload: any) {
      return this.sendToGateway({
         url: `${process.env.REACT_APP_API_URL}/findings_id`,
         method: APIType.DELETE,
         data: payload,
      });
   }

   public static async addVulnerabilityName(payload: any) {
      return this.sendToGateway({
         url: `${process.env.REACT_APP_API_URL}/vulnerability`,
         method: APIType.POST,
         data: payload,
      });
   }

   public static async getVulnerabilityCategories() {
      return this.sendToGateway({
         url: `${process.env.REACT_APP_API_URL}/get_vul_category`,
         method: APIType.GET,
      });
   }

   public static async getVulnerabilityName(payload: any) {
      return this.sendToGateway({
         url: `${process.env.REACT_APP_API_URL}/vulnerability?vul_category=${payload.vul_category}`,
         method: APIType.GET,
      });
   }

   public static async updateFinding(payload: any) {
      return this.sendToGateway({
         url: `${process.env.REACT_APP_API_URL}/findings_id`,
         method: APIType.PUT,
         data: payload,
      });
   }

   public static async saveStep(payload: any) {
      return this.sendToGateway({
         url: `${process.env.REACT_APP_API_URL}/steps`,
         method: APIType.POST,
         data: payload,
      });
   }

   public static async updateStep(payload: any) {
      return this.sendToGateway({
         url: `${process.env.REACT_APP_API_URL}/steps_id`,
         method: APIType.PUT,
         data: payload,
      });
   }

   public static async deleteStep(payload: any) {
      return this.sendToGateway({
         url: `${process.env.REACT_APP_API_URL}/steps_id`,
         method: APIType.DELETE,
         data: payload,
      });
   }

   public static async deleteStepUploadImage(payload: any) {
      return this.sendToGateway({
         url: `${process.env.REACT_APP_API_URL}/image_steps_id`,
         method: APIType.DELETE,
         data: payload,
      });
   }

   public static async generateFinding(payload: any) {
      return this.sendToGateway({
         url: `${process.env.REACT_APP_API_URL}/findings/generate`,
         method: APIType.POST,
         data: payload,
      });
   }

   
   public static async saveReportWithFinding(payload: any) {
      return this.sendToGateway({
         url: `${process.env.REACT_APP_API_URL}/report/save`,
         method: APIType.POST,
         data: payload,
      });
   }

      
   public static async generateReportWithFinding(payload: any) {
      return this.sendToGateway({
         url: `${process.env.REACT_APP_API_URL}/report/generate`,
         method: APIType.POST,
         data: payload,
      });
   }

   public static async generateReportWithFindingExcel(payload: any) {
      return this.sendToGateway({
         url: `${process.env.REACT_APP_API_URL}/report/generate-excel`,
         method: APIType.POST,
         data: payload,
      });
   }

   public static async getDefaultVulnerabilityDetails(payload: any) {
      return this.sendToGateway({
         url: `${process.env.REACT_APP_API_URL}/get_default_vulnearbility_details`,
         method: APIType.POST,
         data: payload,
      });
   }

   public static async createUseCase(payload: any) {
      return this.sendToGateway({
         url: `${process.env.REACT_APP_API_URL}/use_cases`,
         method: APIType.POST,
         data: payload,
      });
   }

   public static async deleteUseCase(useCaseId: string) {
      return this.sendToGateway({
         url: `${process.env.REACT_APP_API_URL}/use_cases/${useCaseId}`,
         method: APIType.DELETE,
      });
   }

   public static async updateUseCase(useCaseId: string, payload: { use_case_name: string }) {
      return this.sendToGateway({
         url: `${process.env.REACT_APP_API_URL}/use_cases/${useCaseId}`,
         method: APIType.PUT,
         data: payload,
      });
   }
}